import './index.scss'
import Swiper from 'swiper/dist/js/swiper.min.js'

$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  $('.pro-detail-banner .bg').css('transform', 'translateY(' + scroH / 3 + 'px)')
});

var section4swiper = new Swiper(".section4 .mySwiper", {
  slidesPerView: 1.2,
  navigation: {
    nextEl: ".section4 .swiper-button-next",
    prevEl: ".section4 .swiper-button-prev",
  },
  pagination: {
    el: ".section4 .swiper-pagination",
    type: "progressbar",
  },
  breakpoints: {
    1024: {
      slidesPerView: 1,
    }
  },
  on: {
    init: function () {
      let total = this.slides.length > 9 ? this.slides.length : '0' + this.slides.length
      $('.section4 .swiper-page .total').html(total)
    },
    transitionStart: function () {
      let activeNum = this.realIndex + 1
      let total = this.slides.length > 9 ? this.slides.length : '0' + this.slides.length
      activeNum = activeNum > 9 ? activeNum : '0' + activeNum
      $('.section4 .swiper-page .active-num').html(activeNum)
      console.log(section4swiper.progress)
      if (section4swiper.progress == 1) {
        $('.section4 .swiper-page .active-num').html(total)
        $(this.slides[this.slides.length - 1]).addClass('active')
      } else {
        $(this.slides[this.slides.length - 1]).removeClass('active')
      }
    },
  }
});

var section3swiper = new Swiper(".section3 .mySwiper", {
  allowTouchMove: false,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoHeight: true,
  on: {
    init: function () {
      $('.section3 .swiper-tab .mycontainer>div').eq(0).addClass('active')
    }
  }
});

$('.section3 .swiper-tab .mycontainer>div').on('click', function () {
  let index = $(this).index()
  $('.section3 .swiper-tab .mycontainer>div').eq(index).addClass('active').siblings().removeClass('active')
  section3swiper.slideTo(index)
})

// $(document).ready(function () {
//   getAWidth()
// })
// $(window).resize(function () {
//   getAWidth()
// })
// function getAWidth() {
//   let domone = Number($('.table thead td').eq(0).outerWidth() + $('.table thead td').eq(1).outerWidth())
//   $(".table-btn div").eq(0).css({ 'width': domone - 1 + 'px' });
//   $.each($('.table thead td'), function (index, value) {
//     $(".table-btn div").eq(index + 1).css({ 'width': $('.table thead td').eq(index + 1).outerWidth() + 'px' });
//   });
//   $(".section3 .table-btn>div a").css({ 'padding-left': '13.2%', 'padding-right': '13.2%' })
//   let numshenqing = Number($('.table thead td').length - 2)
//   let atrnum = ''
//   for (var i = 0; i < numshenqing; i++) {
//     atrnum += `
//   <div><a href="#">申请试用</a></div>
//   `
//   }
//   $(".table-btn").append(atrnum);
// }